import React, { Component } from 'react';
import { SiteTitle, MainWrapper } from '../components/Headings';

const IndexPage = () =>
  <div>
    <MainWrapper>
      <SiteTitle>I'm Kyle Kurtz</SiteTitle>
      Christian, Husband, Father, Builder of Software Products
    </MainWrapper>
  </div>

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.jsx